<template>
  <b-navbar class="blured" v-bind:class="{ 'is-active': dataScroll != 0 }">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ name: 'Home' }">
        <img
          src="../assets/logo.png"
          alt="Portail de questionnaires pour MHConseil"
          width="210px"
          height="46px"
          style="max-height: 46px"
        />
      </b-navbar-item>
    </template>
    <template #end>
      <b-navbar-dropdown
        v-if="user.loggedIn && user.is_su_admin"
        label="Administrer"
      >
        <b-navbar-item @click="openAddUser">
          <b-icon
            icon="account-star"
            type="is-info"
            size="is-small"
            class="mr-1"
          >
          </b-icon>
          <span> </span> <span>Ajouter un super utilisateur</span>
        </b-navbar-item>
      </b-navbar-dropdown>
      <b-navbar-item v-if="user.loggedIn">
        <a class="button" @click.prevent="signOut">Déconnexion</a>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";
import { getAuth, signOut } from "firebase/auth";
import { AddSuperUser } from "../services/dbService";
export default {
  data() {
    return {
      dataScroll: 0,
      currentRoute: "",
    };
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
    }),
  },

  methods: {
    signOut() {
      const auth = getAuth();
      this.$store.dispatch("disconnect");
      signOut(auth).then(() => {
        this.$router.push({ name: "login" });
      });
    },
    openAddUser() {
      this.$buefy.dialog.prompt({
        message: `Veuillez saisir l'email du super utilisateur?`,
        inputAttrs: {
          type: "email",
          required: true,
        },
        confirmText: "Valider",
        cancelText: "Annuler",
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: (value, { close }) => {
          AddSuperUser({
            email: value,
          }).then(() => {
            this.$buefy.snackbar.open({
              message: "Le super utilisateur " + value + " a été ajouté.",
              queue: false,
            });
            close();
          });
        },
      });
    },
  },
};
</script>
